import { render, staticRenderFns } from "./TherapistDashSchedule.vue?vue&type=template&id=23376be1&scoped=true"
import script from "./TherapistDashSchedule.vue?vue&type=script&lang=js"
export * from "./TherapistDashSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23376be1",
  null
  
)

export default component.exports